export const styles = {
	topbar:
		'sticky top-0 z-10 flex items-center justify-between gap-md border-b border-subtle bg-white/95 px-xl py-sm backdrop-blur',
	content: 'flex max-w-[1400px] flex-col gap-xl px-xl py-lg',
	pageEyebrow: 'mb-2xs text-[11px] font-medium uppercase tracking-wider text-purple-700',
	pageH1: 'text-[26px] font-semibold leading-tight tracking-tight text-default',
	pageSub: 'mt-3xs text-[13px] text-subtle',

	rangeToggle: 'inline-flex items-center gap-3xs rounded-md border border-subtle bg-white p-3xs',
	rangeBtn: 'rounded-md px-sm py-3xs text-[12px] font-medium transition-colors',
	rangeBtnActive: 'bg-grey-600 text-white',
	rangeBtnIdle: 'text-subtle hover:bg-grey-25',

	kpiGrid: 'grid grid-cols-1 gap-md sm:grid-cols-3',
	kpiCard: 'flex flex-col gap-3xs rounded-lg border border-subtle bg-white px-md py-sm',
	kpiLabel: 'text-[11px] font-medium uppercase tracking-wider text-subtle',
	kpiValue: 'text-[26px] font-semibold leading-tight tabular-nums text-purple-700',
	kpiSub: 'text-[12px] text-subtle',

	sectionCard: 'flex flex-col gap-sm rounded-lg border border-subtle bg-white px-md py-sm',
	sectionTitle: 'text-[14px] font-semibold text-default',

	stack: 'flex h-[16px] w-full overflow-hidden rounded-full bg-grey-50',
	legend: 'flex flex-wrap items-center gap-md',
	legendItem: 'inline-flex items-center gap-3xs text-[11px] text-subtle',
	legendDot: 'inline-block h-2xs w-2xs shrink-0 rounded-full',
	unpricedNote: 'text-[11px] text-subtle',

	tableWrap: 'overflow-x-auto',
	table: 'min-w-full text-left text-[13px]',
	tableHead: 'border-b border-subtle bg-grey-25 text-[11px] font-medium uppercase tracking-wider text-subtle',
	th: 'px-md py-xs',
	thRight: 'px-md py-xs text-right',
	tr: 'border-b border-subtle/50',
	tdMono: 'px-md py-xs font-mono text-[12px] text-default',
	tdRight: 'px-md py-xs text-right text-[12px] tabular-nums text-default',
	tokenNote: 'text-[11px] text-subtle',
};
